import React from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";
import CustomRadioInput from "./CustomRadioInput";
import RenderFieldError from "./RenderFieldError";
import { useTranslations } from "next-intl";

type TMultiRadioInput = {
  label: string;
  control: Control;
  options: { label: string; value: string }[];
  name: string;
  errors: FieldErrors;
};

const MultiRadioInput = ({
  label,
  control,
  options,
  name,
  errors,
}: TMultiRadioInput) => {
  const t = useTranslations();

  return (
    <div>
      <p className="text-sm font-medium">{label}:</p>
      <div className="flex items-center flex-wrap gap-4 mt-3">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <>
              {options.map((option) => (
                <CustomRadioInput
                  key={option.value}
                  id={option.value}
                  label={t(option.label)}
                  checked={field.value === option.value}
                  onChange={() => field.onChange(option.value)}
                />
              ))}
            </>
          )}
        />

        <RenderFieldError errors={errors} fieldName={name} />
      </div>
    </div>
  );
};

export default MultiRadioInput;
